var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h1", [_vm._v("Setup Guide")]),
      _c("h2", [_vm._v("Step 1: Stripe Account Setup -Optional")]),
      _c("ol", [
        _c("li", [
          _vm._v(
            " Our application allows the option to fully handle all payment transactions thru the Stripe platform. If you intend to use Stripe to handle payments, navigate to the "
          ),
          _c("strong", [_vm._v("Settings")]),
          _vm._v(
            " page by clicking on the gear icon located at the top left of the screen."
          ),
        ]),
        _c("li", [
          _vm._v("Within the "),
          _c("strong", [_vm._v("Settings")]),
          _vm._v(
            " page, find and click on the link to set up a Stripe account for seamless payment processing."
          ),
        ]),
        _c("li", [
          _c("i", [
            _vm._v(
              "You can still leverage the Menu feature if you do not wish to setup Stripe, but payments must be handled outside of the application"
            ),
          ]),
        ]),
      ]),
      _c("h2", [_vm._v("Step 2: Venue Configuration")]),
      _c("ol", [
        _c("li", [
          _vm._v("Access the "),
          _c("strong", [_vm._v("Inventory")]),
          _vm._v(" dropdown in the header."),
        ]),
        _c("li", [
          _vm._v("Choose the "),
          _c("strong", [_vm._v("Venue/Event")]),
          _vm._v(" option to create a venue object."),
        ]),
        _c("li", [
          _vm._v("Once the venue is created, proceed to the "),
          _c("strong", [_vm._v("Bar")]),
          _vm._v(", "),
          _c("strong", [_vm._v("Menu")]),
          _vm._v(", "),
          _c("strong", [_vm._v("Tables")]),
          _vm._v(", and "),
          _c("strong", [_vm._v("Bathroom")]),
          _vm._v(" screens within the "),
          _c("strong", [_vm._v("Inventory")]),
          _vm._v(" dropdown to input associated data for the "),
          _c("strong", [_vm._v("Venue/Event")]),
          _vm._v("."),
        ]),
        _c("li", [
          _vm._v(
            "Enable, disable, or delete data as needed for each section. Be advised, a "
          ),
          _c("strong", [_vm._v("Bar")]),
          _vm._v(" or "),
          _c("strong", [_vm._v("Table")]),
          _vm._v(" must be setup to receive orders."),
        ]),
      ]),
      _c("h2", [_vm._v("Step 3: QR Code Generation")]),
      _c("ol", [
        _c("li", [
          _vm._v("Navigate to the "),
          _c("strong", [_vm._v("Operations")]),
          _vm._v(" dropdown in the header."),
        ]),
        _c("li", [
          _vm._v("Select the "),
          _c("strong", [_vm._v("Generate QR Code")]),
          _vm._v(" screen to create a barcode for the venue."),
        ]),
        _c("li", [
          _vm._v(
            "Alternatively, retrieve the necessary text for the barcode for self-printing."
          ),
        ]),
      ]),
      _c("h2", [_vm._v("Step 4: User Account Setup")]),
      _c("ol", [
        _c("li", [
          _vm._v(
            "For additional associates working for the business, instruct them to create their own account on the website."
          ),
        ]),
        _c("li", [
          _vm._v(
            "Associates should reference the Employee Code on the main screen during account creation."
          ),
        ]),
      ]),
      _c("h2", [_vm._v("Step 5: Managing Orders")]),
      _c("ol", [
        _c("li", [
          _vm._v("The main account has the capability to accept orders."),
        ]),
        _c("li", [
          _vm._v(
            "Associates can accept orders, enable/disable items, but have limited actions."
          ),
        ]),
        _c("li", [
          _vm._v("To handle live orders, navigate to the "),
          _c("strong", [_vm._v("Live Orders")]),
          _vm._v(" screen in the "),
          _c("strong", [_vm._v("Operations")]),
          _vm._v(" dropdown."),
        ]),
        _c("li", [
          _vm._v("Process and manage orders by accepting or denying them."),
        ]),
      ]),
      _c("h2", [_vm._v("Mobile App Usage")]),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Users will utilize the mobile app to scan the barcode and create orders seamlessly."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }